export enum TextGenerationFlag {
    NONE = 0,
    MIRRORED_X = 2,
    MIRRORED_Y = 4,
}

export enum TextHorizontalAlign {
    LEFT = 0,
    CENTER = 1,
    RIGHT = 2,
    ALIGNED = 3,
    MIDDLE = 4,
    FIT = 5,
}

export enum TextVerticalAlign {
    BASELINE = 0,
    BOTTOM = 1,
    MIDDLE = 2,
    TOP = 3,
}
